import { render } from "./packageDialog.vue?vue&type=template&id=019dce47&scoped=true"
import script from "./packageDialog.vue?vue&type=script&lang=js"
export * from "./packageDialog.vue?vue&type=script&lang=js"

import "./packageDialog.vue?vue&type=style&index=0&id=019dce47&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019dce47"]])

export default __exports__